import ky from 'ky'

export const API_CONTEXT = import.meta.env.VITE_API_CONTEXT

export const apiInstance = ky.extend({
    headers: {
        'Content-Type': 'application/json',
    },
    prefixUrl: API_CONTEXT,
    retry: 0,
})
